export default class FootnoteHelper {
    setup() {
        if (document.querySelector('.digital-publication-v2')) {
            const footnoteRefs = document.querySelectorAll(
                'sup a[href*="footnote"]:not([href*="-ref-"])'
            );
            footnoteRefs && this.connectFootnotes(footnoteRefs);
        }
    }
    connectFootnotes(footnoteRefs) {
        footnoteRefs.forEach((footnoteRef) => {
            const href = footnoteRef.getAttribute('href') || '';
            const hrefParts = href.split('-');
            const id = hrefParts.pop();
            const ref = hrefParts.join('-') + '-ref-' + id;

            if (footnoteRef && !footnoteRef.id) {
                footnoteRef.id = ref.replace('#', '');
            }

            const footnote = document.querySelector(`a[href="${ref}"]`);
            if (footnote && !footnote.id) {
                footnote.id = href.replace('#', '');
            }
        });
    }
}